import React from 'react'
import './Checkbox.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

export default function Checkbox(props) {
    return (
        <>
            <div className={`checkboxContainer ${props.customClass} ${props.checked ? '' : 'checkboxContainerDisabled'}`} onClick={(e) => { e.stopPropagation(); props.onMouseDown(e) }} style={props.customStyles} name={`${props.name ? props.name : ''}`}>
                <FontAwesomeIcon icon={faCheck} className={`checkboxCheckmark ${props.checked ? '' : 'checkboxCheckmarkDisabled'}`} style={props.customCheckmarkStyles} />
            </div>
        </>
    )
}
